import { BookingActionTypes } from '../action-types/bookingTypes';
import { BookingActions } from '../actions/bookingTypes';
import { Dispatch } from 'redux';

export const setHasConfirmedPayment = (value: boolean) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_HAS_CONFIRMED_PAYMENT,
      payload: value,
    });
  };
};

export const setTravelCancellation = (value: boolean) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_TRAVEL_CANCELLATION,
      payload: value,
    });
  };
};

export const setCovidProtection = (value: boolean) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_COVID_PROTECTION,
      payload: value,
    });
  };
};

export const setExcess = (value: boolean) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_EXCESS,
      payload: value,
    });
  };
};

export const setHideJV = (value: boolean) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_HIDE_JV,
      payload: value,
    });
  };
};

export const setPaymentMethod = (paymentMethod: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_PAYMENT_METHOD,
      payload: paymentMethod,
    });
  };
};

export const setPersons = (persons: Array<Person>) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_PERSONS,
      payload: persons,
    });
  };
};

export const setPolicyHolderIBAN = (iban: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_IBAN,
      payload: iban,
    });
  };
};

export const setPolicyHolderAccountHolder = (accountHolder: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_ACCOUNT_HOLDER,
      payload: accountHolder,
    });
  };
};

export const setHasConfirmedPrecontractualDocuments = (hasConfirmed: boolean) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_HAS_CONFIRMED_PRECONTRACTUAL_DOCUMENTS,
      payload: hasConfirmed,
    });
  };
};

export const setPolicyHolderPhone = (phone: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_PHONE,
      payload: phone,
    });
  };
};

export const setPolicyHolderEmail = (email: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_EMAIL,
      payload: email,
    });
  };
};

export const setPolicyHolderEmail2 = (email: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_EMAIL2,
      payload: email,
    });
  };
};

export const setPolicyHolderSalutation = (salutation: SalutationsType) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_SALUTATION,
      payload: salutation,
    });
  };
};

export const setPolicyHolderFirstName = (firstName: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_FIRST_NAME,
      payload: firstName,
    });
  };
};

export const setPolicyHolderLastName = (lastName: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_LAST_NAME,
      payload: lastName,
    });
  };
};

export const setPolicyHolderCompany = (company: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_COMPANY,
      payload: company,
    });
  };
};

export const setPolicyHolderSamePerson = (samePerson: boolean) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_SAME_PERSON,
      payload: samePerson,
    });
  };
};

export const setPolicyHolderStreet = (street: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_STREET,
      payload: street,
    });
  };
};

export const setPolicyHolderPostalCode = (postalCode: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_POSTAL_CODE,
      payload: postalCode,
    });
  };
};

export const setPolicyHolderCity = (city: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_CITY,
      payload: city,
    });
  };
};

export const setPolicyHolderCountry = (country: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_POLICY_HOLDER_COUNTRY,
      payload: country,
    });
  };
};

export const setPlaceOfResidence = (country: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_RESIDENCE,
      payload: country,
    });
  };
};

export const setStartDate = (startDate: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_START_DATE,
      payload: startDate,
    });
  };
};

export const setEndDate = (endDate: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_END_DATE,
      payload: endDate,
    });
  };
};

export const setBookingConfirmationDate = (bookingConfirmationDate: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_BOOKING_CONFIRMATION_DATE,
      payload: bookingConfirmationDate,
    });
  };
};

export const setCategory = (category: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_CATEGORY,
      payload: category,
    });
  };
};

export const setCategoryTrackingId = (categoryTrackingId: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_CATEGORY_TRACKING_ID,
      payload: categoryTrackingId,
    });
  };
};

export const setTravelers = (travelers: TravelersType) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_TRAVELERS,
      payload: travelers,
    });
  };
};

export const setRental = (rental: boolean) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_RENTAL,
      payload: rental,
    });
  };
};

export const setExcessAmount = (amount: number) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_EXCESS_AMOUNT,
      payload: amount,
    });
  };
};

export const setTripCost = (tripCost: number | undefined) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_TRIP_COST,
      payload: tripCost,
    });
  };
};

export const setGeographicalZone = (geographicalZone: GeographicalZoneType) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_GEOGRAPHICAL_ZONE,
      payload: geographicalZone,
    });
  };
};

export const setMeansOfTravel = (meansOfTravel: MeansOfTravelType) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_MEANS_OF_TRAVEL,
      payload: meansOfTravel,
    });
  };
};

export const setErgoOrganisationUnit = (ergoOrganisationUnit: ErgoOrganisationUnitType) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_ERGO_ORGANISATION_UNIT,
      payload: ergoOrganisationUnit,
    });
  };
};
export const setOenr1 = (oenr1: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_OENR1,
      payload: oenr1,
    });
  };
};

export const setWayOfAccess = (wayOfAccess: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_WAY_OF_ACCESS,
      payload: wayOfAccess,
    });
  };
};

export const setDisplayTripCost = (displayTripCost: string | undefined) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_DISPLAY_TRIP_COST,
      payload: displayTripCost,
    });
  };
};

export const setDisplayIndividualTripCost = (
  displayIndividualTripCost: Array<string> | undefined,
) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_DISPLAY_INDIVIDUAL_TRIP_COST,
      payload: displayIndividualTripCost,
    });
  };
};

export const setAgent = (agent: string) => {
  return (dispatch: Dispatch<BookingActions>) => {
    dispatch({
      type: BookingActionTypes.SET_AGENT,
      payload: agent,
    });
  };
};
